import { useTran } from "@/hooks";

const ESGReportAppendix = ({ framework }) => {
  const { t } = useTran();
  return (
    <div
      className="esg-page-break esg-avoid-break bg-white p-12 flex flex-col"
      style={{ minHeight: "100vh" }}
    >
      <h2 className="mb-8 text-3xl font-bold text-slate-900">
        {t("Appendix")}
      </h2>

      <div className="esg-appendix-section mb-8">
        <h3 className="mb-4 text-xl font-bold text-slate-700">
          {t("Sample Indicator Tables")}
        </h3>
        <p className="mb-4 text-sm text-slate-600 leading-relaxed">
          {t(
            "The performance tables in this report present disclosure data organized by ESG pillars. Each indicator includes the disclosure code, title, value, and unit.",
          )}
        </p>
        <ul className="ml-6 space-y-2 text-sm text-slate-600">
          <li className="flex items-start gap-2">
            <span className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-slate-400" />
            <span>
              <strong>{t("Code")}:</strong>{" "}
              {t("Unique disclosure identifier per {{framework}} framework", {
                framework,
              })}
            </span>
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-slate-400" />
            <span>
              <strong>{t("Indicator")}:</strong>{" "}
              {t("Description of the disclosure requirement")}
            </span>
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-slate-400" />
            <span>
              <strong>{t("Value")}:</strong>{" "}
              {t("Reported metric or data point")}
            </span>
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-slate-400" />
            <span>
              <strong>{t("Unit")}:</strong>{" "}
              {t("Measurement unit (e.g., tCO2e, kWh, %)")}
            </span>
          </li>
        </ul>
      </div>

      <div className="esg-appendix-section mb-8">
        <h3 className="mb-4 text-xl font-bold text-slate-700">
          {t("Methodology Notes")}
        </h3>
        <div className="space-y-3 text-sm text-slate-600">
          <p>
            <strong>{t("Data Collection")}:</strong>{" "}
            {t(
              "Disclosed data is collected through the ESG management platform and reviewed before inclusion.",
            )}
          </p>
          <p>
            <strong>{t("Reporting Period")}:</strong>{" "}
            {t(
              "Metrics reflect the reporting period stated on the cover page.",
            )}
          </p>
          <p>
            <strong>{t("Completion Status")}:</strong>{" "}
            {t(
              "Completed disclosures have been reviewed and include supporting documentation where applicable.",
            )}
          </p>
        </div>
      </div>

      <div className="esg-appendix-section">
        <h3 className="mb-4 text-xl font-bold text-slate-700">
          {t("Glossary")}
        </h3>
        <div className="space-y-3 text-sm">
          <div>
            <strong className="text-slate-900">ESG:</strong>{" "}
            <span className="text-slate-600">
              {t("Environmental, Social, and Governance.")}
            </span>
          </div>
          <div>
            <strong className="text-slate-900">{t("Disclosure")}:</strong>{" "}
            <span className="text-slate-600">
              {t(
                "A reporting requirement defined by the {{framework}} framework.",
                { framework },
              )}
            </span>
          </div>
          <div>
            <strong className="text-slate-900">tCO2e:</strong>{" "}
            <span className="text-slate-600">
              {t("Metric tonnes of carbon dioxide equivalent.")}
            </span>
          </div>
        </div>
      </div>

      <div className="mt-6 rounded-lg border border-slate-200 bg-slate-50 p-4">
        <p className="text-xs text-slate-600 leading-relaxed">
          <strong>{t("Note")}:</strong>{" "}
          {t(
            "For questions regarding disclosures or data sources, please contact your ESG reporting coordinator.",
          )}
        </p>
      </div>

      <div className="mt-auto esg-report-footer">
        {t("End of Report - Generated on {{date}}", {
          date: new Date().toLocaleString(),
        })}
      </div>
    </div>
  );
};

export default ESGReportAppendix;
